<template>
  <div class="attr-wrap">
    <template v-if="attrs.length > 0">
      <div
        class="mask"
        v-show="expandAttr"
        @click.stop="expandAttr = false"
      ></div>
      <a class="change" @click="expandAttr = !expandAttr">
        <img class="img" src="@/assets/images/exam/bar-line-theme@2x.png" />
        <span>切换</span>
      </a>
      <span class="selected-name" :class="{ right: pos == 'right' }">
        {{ selectedName }}
      </span>
      <div
        class="classify"
        :class="{ right: pos == 'right' }"
        v-if="expandAttr"
      >
        <Classify
          :items="classifyItems"
          enableToggleClick
          @change="onClassifyChange"
        ></Classify>
        <div class="btn" @click="onConfirmAttr">确定</div>
      </div>
    </template>
  </div>
</template>
<script>
import Classify from "../../../components/Classify.vue";
export default {
  name: "ExamAttrSetting",
  components: { Classify },
  props: {
    // 位置 left / right
    pos: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {
      attrCondition: {},
      attrs: [],
      expandAttr: false,
      selectedName: "",
    };
  },
  computed: {
    classifyItems() {
      let items = [];
      this.attrs.forEach(c => {
        let item = {
          id: c.id,
          name: c.attr,
          value: { item: this.attrCondition[c.id] },
          children: c.value,
        };
        items.push(item);
      });
      return items;
    },
  },
  async created() {
    this.attrCondition = await this.$services.ExamService.getAttr();
    this.attrs = await this.$http.get("/api/app/attribute/4");
    this.attrs.forEach(attr => {
      this.attrCondition[attr.id] = this.attrCondition[attr.id] || 0;
    });
    this.setSelectedName();
    this.$emit("created");
    if (
      (this.$storage().get("has-set-exam-attr") || {})[
        this.$store.state.user_info.id
      ] != 1 &&
      this.selectedName == ""
    ) {
      this.expandAttr = true;
    }
  },
  methods: {
    setSelectedName() {
      let names = [];
      for (let key in this.attrCondition) {
        let attr = this.attrs.find(a => a.id == key);
        if (!attr) {
          continue;
        }
        let valId = this.attrCondition[key];
        if (valId == 0) {
          continue;
        }
        let value = attr.value.find(v => v.id == valId);
        if (!value) {
          continue;
        }
        names.push(value.name);
      }
      this.selectedName = names.join(" | ");
    },
    getAttrValId(includeAll = false) {
      let ids = [];
      for (let key in this.attrCondition) {
        let id = this.attrCondition[key];
        if (id > 0 || includeAll) {
          ids.push(id);
        }
      }
      return ids.join(",");
    },

    onClassifyChange({ id, value }) {
      this.attrCondition[id] = value.item;
    },
    async onConfirmAttr() {
      await this.$services.ExamService.setAttr(this.attrCondition);
      let userSetting = this.$storage().get("has-set-exam-attr") || {};
      userSetting[this.$store.state.user_info.id] = 1;
      this.$storage().set("has-set-exam-attr", userSetting);
      this.setSelectedName();
      this.expandAttr = false;
      this.$emit("save");
    },
  },
};
</script>
<style lang="scss" scoped>
.attr-wrap {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }

  .img {
    width: 18px;
    height: 12px;
    margin-right: 7px;
  }

  .change {
    font-size: 16px;
    color: $primary-color;
    line-height: 1;
    cursor: pointer;
  }

  .classify {
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border-radius: 8px;
    top: 45px;
    position: absolute;
    z-index: 9999;
    min-width: 450px;
    max-width: 900px;
    &.right {
      right: 0;
      &::before {
        left: auto;
        right: 25px;
      }
    }

    &::before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-bottom-color: white;
      left: 25px;
      top: -20px;
    }
  }

  .btn {
    width: 94px;
    height: 32px;
    background: $primary-color;
    border-radius: 3px;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    margin: 0 auto 30px auto;
    color: white;
    cursor: pointer;
  }
  .selected-name {
    font-size: 16px;
    color: rgba(52, 52, 52, 1);
    line-height: 1;
    margin-left: 8px;
    &.right {
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
